import { api } from "./client";
import type { Paginated, Shop, User } from "./types";

export interface BulkUploadResult {
  upload_id: string;
  total_rows: number;
  successful_rows: number;
  failed_rows: number;
  created_users: {
    row_number: number;
    email: string;
    full_name: string;
    temp_password: string;
  }[];
  errors: { row_number: number; email: string; reason: string }[];
  credentials_csv_url: string;
}

export const usersApi = {
  list: (params: Record<string, unknown> = {}) =>
    api.get<Paginated<User>>("/users/", { params }).then((r) => r.data),
  create: (payload: Partial<User>) =>
    api
      .post<User & { temp_password: string }>("/users/", payload)
      .then((r) => r.data),
  get: (id: string) => api.get<User>(`/users/${id}/`).then((r) => r.data),
  update: (id: string, payload: Partial<User>) =>
    api.patch<User>(`/users/${id}/`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/users/${id}/`),
  resetPassword: (id: string) =>
    api.post<{ temp_password: string }>(`/users/${id}/reset-password/`).then((r) => r.data),
  revokeSessions: (id: string) => api.post(`/users/${id}/revoke-sessions/`),
  bulkUpload: (file: File) => {
    const body = new FormData();
    body.append("file", file);
    return api.post<BulkUploadResult>("/users/bulk-upload/", body).then((r) => r.data);
  },
  bulkTemplateUrl: () => "/api/v1/users/bulk-upload/template/",
  credentialsUrl: (uploadId: string) => `/api/v1/users/bulk-upload/${uploadId}/credentials.csv`,
  listAllocatedShops: (id: string) =>
    api.get<Shop[]>(`/users/${id}/shops/`).then((r) => r.data),
  setAllocatedShops: (id: string, shopIds: string[]) =>
    api.put<Shop[]>(`/users/${id}/shops/`, { shop_ids: shopIds }).then((r) => r.data),
};
